/**
 * @file Confirm user email view.
 */

import React from 'react';
import Helmet from 'react-helmet';

import MainLayout from '../layouts/MainLayout';
import ContentWrap from '../../components/global/ContentWrap';
import EmailVerifyContainer from '../../containers/auth/EmailVerifyContainer';

const EmailConfirmView = () => (
  <MainLayout>
    <Helmet>
      <title>Email verification &ndash; Waldo</title>
    </Helmet>

    <ContentWrap size="sm">
      <EmailVerifyContainer />
    </ContentWrap>
  </MainLayout>
);

export default EmailConfirmView;
